// The theme's tints, taken in turn so no two neighbours match.
const tints = ['bg-tint-1', 'bg-tint-2', 'bg-tint-3', 'bg-tint-4', 'bg-tint-5', 'bg-tint-6']
export const tint = (index: number) => tints[index % tints.length]
